import { Maybe } from 'types/FMSGraphqlTypes'
import {
  EXCLUDED_COMMODITIES_LABELS,
  IExcludedCommodities,
} from '../components/ExcludedCommoditiesModal/types'

export const getExcludedCommoditiesLabels = (excludedCommodities: string[]): Maybe<string> => {
  if (!excludedCommodities.length) {
    return null
  }

  return excludedCommodities
    .map(commodity => EXCLUDED_COMMODITIES_LABELS[commodity as IExcludedCommodities] || commodity)
    .join(', ')
}
